import React, { useEffect, useRef } from 'react';
import './Loader.css';

const Loader = ({ onComplete }) => {
  const loaderRef = useRef(null);
  const progressRef = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    // Animación de la barra de progreso
    const progressBar = progressRef.current;
    progressBar.style.width = '100%';

    // Animación del texto
    const text = textRef.current;
    text.style.opacity = '1';
    text.style.transform = 'translateY(0)';

    // Cuando termine la carga (después de 3 segundos)
    const timer = setTimeout(() => {
      // Fade out del loader
      loaderRef.current.classList.add('fade-out');
      
      // Llamar a onComplete después del fade out
      setTimeout(() => {
        if (onComplete) onComplete();
      }, 800);
    }, 3000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="loader" ref={loaderRef}>
      <div className="loader-content">
        <h1 className="loader-title" ref={textRef}>
          Angelika Erta
        </h1>
        <div className="progress-container">
          <div className="progress-bar" ref={progressRef}></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;